import React, { useContext, useEffect, useState } from "react";
import WebFrontNavbar from "./WebStoreNavbar";

import StoreHero from "./HeroSection";
import StoreDeal from "./BestDealsSection";
import StoreProducts from "./WebStoreProducts";
import StoreOverview from "./CompanyOverview";
import Offer from "./OfferSection";
import AboutSection from "./AboutUs";
import StoreInquiry from "./WebStoreInquiry";
import ContactUs from "./ContactSection";
import { getWebStoreDetailsApi } from "../../Apis/WebStoreApi";
import { UserAuthContext } from "../../App";


const WebFrontStore = () => {

  const { userUid } = useContext(UserAuthContext);
  const [webStoreDetails, setWebStoreDetails] = useState(null);

  useEffect(() => {
    const fetchWebStoreDetails = async () => {
      try {
        const response = await getWebStoreDetailsApi(userUid?.currentUser?.uid);
        setWebStoreDetails(response?.webStoreDetails);
      } catch (error) {
        console.error("Failed to fetch web store details", error);
      }
    };

    fetchWebStoreDetails();
  }, [userUid?.currentUser?.uid]);

  return (
    <div className="bg-white">
      <WebFrontNavbar />
      <StoreHero bannerImages={webStoreDetails?.bannerImages} />
      <StoreDeal onTopInclude={webStoreDetails?.onTopInclude} />
      {/* <StoreHero />
      <StoreDeal /> */}
      <StoreProducts />
      <StoreOverview companyOverview={webStoreDetails?.companyOverview} />
      <Offer features={webStoreDetails?.features}/>
      <AboutSection aboutUs={webStoreDetails?.aboutUs}/>
      <StoreInquiry />
      <ContactUs />
    </div>
  );
};

export default WebFrontStore;
